// Bloquer les clics sur la slide hero sauf sur le bouton
document.addEventListener('click', function(e) {
  var heroSection = document.getElementById('shopify-section-hero_banner');
  if (!heroSection) return;
  if (!heroSection.contains(e.target)) return;
  // Si c'est un vrai bouton, laisser passer
  if (e.target.closest('.link-btn') || e.target.closest('[class*="btn"]') || e.target.closest('button')) return;
  // Sinon bloquer
  var link = e.target.closest('a');
  if (link && !link.closest('.link-btn')) {
    e.preventDefault();
    e.stopPropagation();
  }
}, true);

// Menu overlay - Ming The
document.addEventListener('DOMContentLoaded', function() {

  var overlay = document.createElement('div');
  overlay.id = 'ming-menu-overlay';

  var panel = document.createElement('div');
  panel.id = 'ming-menu-panel';

  var closeBtn = document.createElement('button');
  closeBtn.id = 'ming-menu-close';
  closeBtn.innerHTML = '&times;';
  closeBtn.setAttribute('aria-label', 'Fermer le menu');

  var navLinks = document.querySelectorAll('#nav a[href]');
  var ul = document.createElement('ul');

  if (navLinks.length === 0) {
    var links = [
      {text: 'Accueil', href: '/'},
      {text: 'The Noir', href: '/collections/the-noir'},
      {text: 'The Vert', href: '/collections/the-vert'},
      {text: 'Matcha', href: '/collections/macha'},
      {text: 'Qui sommes-nous', href: '/pages/qui-sommes-nous'},
      {text: 'Les Plantations', href: '/pages/les-plantations'}
    ];
    links.forEach(function(link) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = link.href;
      a.textContent = link.text;
      li.appendChild(a);
      ul.appendChild(li);
    });
  } else {
    var seen = {};
    navLinks.forEach(function(link) {
      var href = link.getAttribute('href');
      var text = link.textContent.trim();
      if (!seen[href] && text && !link.closest('.dropdown')) {
        seen[href] = true;
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = href;
        a.textContent = text;
        li.appendChild(a);
        ul.appendChild(li);
      }
    });
  }

  panel.appendChild(closeBtn);
  panel.appendChild(ul);
  overlay.appendChild(panel);
  document.body.appendChild(overlay);

  function openMenu() {
    overlay.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    overlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  var menuBtn = document.querySelector('#header-inner .link-btn a:first-child');
  if (menuBtn) {
    menuBtn.addEventListener('click', function(e) {
      e.preventDefault();
      if (overlay.classList.contains('open')) {
        closeMenu();
      } else {
        openMenu();
      }
    });
  }

  closeBtn.addEventListener('click', closeMenu);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeMenu();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeMenu();
  });

});

// Prix au gramme - Ming The
(function() {
  if (!window.location.pathname.includes('/products/')) return;
  var handle = window.location.pathname.split('/products/')[1].split('?')[0].split('/')[0];
  var variants = {};

  fetch('/products/' + handle + '.js')
    .then(function(r){return r.json();})
    .then(function(p){
      p.variants.forEach(function(v){ variants[String(v.id)] = {price: v.price/100, title: v.title}; });
      update();
    });

  function getGrams(title) {
    var m = title ? title.match(/(\d+)\s*g/) : null;
    return m ? parseInt(m[1]) : null;
  }

  function show(price, grams) {
    var el = document.getElementById('ppg');
    if (el) el.remove();
    if (!grams || !price) return;
    var p = document.createElement('p');
    p.id = 'ppg';
    p.style.cssText = 'font-size:0.85rem;color:#888;margin-top:4px;margin-bottom:8px;';
    p.textContent = '(' + (price/grams).toFixed(2).replace('.',',') + '\u20ac/g)';
    var ref = document.querySelector('.f8pr-price');
    if (ref) ref.insertAdjacentElement('afterend', p);
  }

  function updatePrice(variantId) {
    var v = variants[String(variantId)];
    if (!v) return;
    var priceEl = document.querySelector('.f8pr-price');
    if (priceEl) {
      var formatted = v.price.toFixed(2).replace('.', ',') + '\u00a0\u20ac';
      priceEl.textContent = formatted;
    }
    show(v.price, getGrams(v.title));
  }

  function update() {
    var inputs = document.querySelectorAll('input[name="id"]');
    var checked = null;
    inputs.forEach(function(inp) { if (inp.checked) checked = inp; });
    if (!checked && inputs.length) checked = inputs[0];
    if (checked) updatePrice(checked.value);
  }

  document.addEventListener('click', function(e) {
    var li = e.target.closest('li');
    if (!li) return;
    var inp = li.querySelector('input[name="id"]');
    if (!inp) return;
    setTimeout(function() { updatePrice(inp.value); }, 50);
  });

  setTimeout(update, 800);
})();
